import { render } from "./AddAuteur.vue?vue&type=template&id=3b23f932&ts=true"
import script from "./AddAuteur.vue?vue&type=script&lang=ts"
export * from "./AddAuteur.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__